import { CalendarX2 } from 'lucide-react';

import { cn } from '../../../../lib/utils';

/** Whether an activity can be booked now; 'none' = approved but not bookable yet. */
export type ActivityAvailability = 'bookable' | 'none';

export interface UnavailableBadgeProps {
  /** Translated label, e.g. "No availability yet". */
  text: string;
  className?: string;
}

/**
 * Marks an activity that cannot be booked right now (no upcoming available
 * slot). Muted on purpose: the card stays browsable, it just is not bookable.
 */
export const UnavailableBadge = ({ text, className }: UnavailableBadgeProps) => (
  <span
    className={cn(
      'inline-flex items-center gap-1 rounded-full bg-background/95 px-2 py-0.5 text-[11px] font-medium leading-4 text-muted-foreground shadow-sm',
      className
    )}
  >
    <CalendarX2 className="h-3 w-3 shrink-0" aria-hidden="true" />
    <span className="truncate">{text}</span>
  </span>
);
